import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import { makeGetWorkspaceCustomFieldValueById } from '../../../../../redux/workspace/selectors';

const ConnectedTaskWorkspaceCustomFieldValue = ({ customFieldValue, customFieldValueId }) => {
  const value = useMemo(() => {
    if (customFieldValue?.label) return customFieldValue.label;
    if (customFieldValueId !== null && typeof customFieldValueId === 'object') {
      return customFieldValueId.label || customFieldValueId.email || null;
    }
    return customFieldValueId;
  }, [customFieldValue, customFieldValueId]);
  const style = useMemo(() => {
    if (!customFieldValue?.metadata?.color) return {};
    
    return {
      background: customFieldValue?.metadata?.color,
      color: '#fff',
      margin: '0.25rem',
      boxSizing: 'border-box',
      padding: '0 7px',
      fontSize: '12px',
      lineHeight: '20px',
      whiteSpace: 'nowrap',
      borderRadius: '4px'
    }
  }, [customFieldValue]);

  return (
    <div className='text-center text-xs' style={style}>
      {value}
    </div>
  );
};

const makeMapStateToProps = () => {
  const getWorkspaceCustomFieldValueById = makeGetWorkspaceCustomFieldValueById();
  return (state, props) => ({
    customFieldValue: getWorkspaceCustomFieldValueById(state, {
      customFieldId: props?.customFieldId,
      customFieldValueId: props?.customFieldValueId,
      projectId: props?.projectId
    }),
  });
};

export default connect(makeMapStateToProps)(ConnectedTaskWorkspaceCustomFieldValue);
